/**
 * 시세 차트 · 등급별 시세표 API.
 *
 * 값은 공용 서버(common-server)에 있고 관리자 서버가 중계한다. 수수료를 아는 쪽이
 * 거기뿐이라 계산도 거기서 한다 — 이 화면은 받은 숫자를 그리기만 한다.
 *
 * 권한: HQ(본사) 관리자 전용
 */
import api from './index'

const BASE = '/api/v1/metal-price'

/**
 * 차트용 이력. 금속 하나를 **기본가격 · 살 때 · 팔 때** 세 줄로 받는다.
 *
 * 점마다 **그 시점의 수수료**가 붙어 온다. 수수료를 바꾼 날 선이 꺾이는데,
 * 실제로 그날부터 다른 값으로 거래했으니 그게 맞다. 수수료를 걸기 전의 구간은
 * 지금 쓰는 수수료로 칠한다 — 그래야 "오늘 기준으로 보면 그때 이랬다" 가 된다.
 *
 * @param {Object} p
 *   @param {string} p.tenant    GOLDNARA / AURA
 *   @param {string} p.metal     GOLD / SILVER / PLATINUM
 *   @param {string} [p.basis]   KRX / SPOT. 비우면 금속의 기본 기준
 *   @param {string} [p.from]    ISO 시각. 비우면 90일 전
 *   @param {string} [p.to]
 *   @param {string} [p.interval] day(기본) / hour — 수집이 분당 1회라 날것은 못 쓴다
 */
export function getPriceHistory({ tenant = 'GOLDNARA', metal = 'GOLD', basis, from, to, interval = 'day' } = {}) {
  return api.get(`${BASE}/history`, {
    params: { tenant, metal, basis: basis || undefined, from, to, interval },
  })
}

/**
 * 등급별 시세표. 순금 · 22K · 18K · 14K · 10K · 순은 · 순백금.
 *
 * 홈페이지 헤더의 "오늘의 거래 기준가" 가 쓰는 것과 **같은 값**이다.
 * 이 화면에 두는 이유는 그것 — 밖으로 나가는 숫자를 관리자가 그대로 확인할 수 있다.
 *
 * @param {number|string} gramsPerUnit 1 이면 원/g, 3.75 면 원/돈
 */
export function getPriceBoard(tenant = 'GOLDNARA', gramsPerUnit = 3.75) {
  return api.get(`${BASE}/board`, { params: { tenant, gramsPerUnit } })
}
